import { cn } from '@/lib/utils'
import { NO_INFORMATION } from './quoteCardTypes'

interface CarrierDetailRowProps {
  label: string
  value?: string | null
  /** Puts the value on its own line — for prose long enough to wrap past the label. */
  stacked?: boolean
}

/** A carrier-details row with nothing to expand: its label and the one value behind it. */
export function CarrierDetailRow({ label, value, stacked }: CarrierDetailRowProps) {
  return (
    <div
      className={cn(
        'flex px-2 py-4 text-xs',
        stacked ? 'flex-col gap-1' : 'items-baseline justify-between gap-2'
      )}
    >
      <span className="text-foreground font-medium">{label}</span>
      <span className={cn('font-normal', value ? 'text-muted-foreground' : 'text-ink-300')}>
        {value || NO_INFORMATION}
      </span>
    </div>
  )
}
